import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react'
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';
import { regexConstants } from '../../../../constants/regEx';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { addAdditionalTaxTypeApi, updateAdditionalTaxTypeApi } from '../apiServices';
import { checkApiStatus } from '../../../../utils';
import { enqueueSnackbar } from 'notistack';
import { trackActivity } from '../../../../utils/mixpanel';

const AdditionalTaxTypeCRU = ({ additionalTaxTypeCRU, modeType, getResponseBack, onToggleModal, params }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [additionaltaxTypeData, setAdditionalTaxTypeData] = useState(additionalTaxTypeCRU?.data);
  const [error, setError] = useState({})

  const handelInputChange = (keyParam, value) => {
    setAdditionalTaxTypeData({ ...additionaltaxTypeData, [keyParam]: value });

  }
  const onRestErrorKey = (keyParam) => {
    setError({ ...error, [keyParam]: '' })
  }

  // Temporarily disabled — Negative Tax Type support is on hold. Re-enable this list
  // (and the Type Autocomplete field below) to restore Type selection.
  // const AdditionalTaxTypeOptions = [
  //       { label: 'Positive', value: 1 },
  //       { label: 'Negative', value: 2 },
  //   ]

  const addEditAdditionalTaxType = () => {
    let validationInputs = {};
    validationInputs = {
      name: additionaltaxTypeData?.name?.trim() ? "" : "Please enter Name",
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      setIsLoading(true);
      // Type selection is temporarily disabled — always send Positive (1) regardless of any
      // previously stored value (e.g. when editing an older record).
      const payload = { ...additionaltaxTypeData, type: 1 };
      if (additionaltaxTypeData?.id) {
        globalPutService(updateAdditionalTaxTypeApi({ asset_slug: additionaltaxTypeData?.slug }), payload)
          .then((response) => {
            if (checkApiStatus(response)) {
              setIsLoading(false);
              onToggleModal();
              getResponseBack();
              enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
              trackActivity('Item Edited', { page_title: `Edit Additional Tax Type`, success_msg: response?.data?.message, item_id: additionaltaxTypeData?.id, payload: payload, response: response?.data })
            } else {
              setIsLoading(false);
              enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
              trackActivity('Item Edited', { page_title: `Edit Additional Tax Type`, error_msg: response?.data?.message, item_id: additionaltaxTypeData?.id, payload: payload, response: response?.data })
            }
          })
      } else {
        globalPostService(addAdditionalTaxTypeApi(), payload)
          .then((response) => {
            if (checkApiStatus(response)) {
              setIsLoading(false);
              onToggleModal();
              getResponseBack();
              enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
              trackActivity('Item Added', { page_title: `Add Additional Tax Type`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: payload, response: response?.data })
            } else {
              setIsLoading(false);
              enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
              trackActivity('Item Added', { page_title: `Add Additional Tax Type`, error_msg: response?.data?.message, item_id: null, payload: payload, response: response?.data })
            }
          })
      }
    } else {
      setError(validationInputs)
      trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Additional Tax Type`, error_msg: validationInputs, })
    }
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Additional Tax Type`, page_type: page_type, })
  }
  return (
    <>
      <Dialog aria-labelledby="customized-dialog-title" className="add-lease-dialog" maxWidth="md" fullWidth open={true}>
        <DialogTitle sx={{ m: 0, p: 2 }} style={{ position: 'sticky' }} className='dialog-header'>
          <Typography sx={{ marginLeft: '10px' }}> {modeType === "add" ? "Add Additional Tax Type" : modeType === "edit" ? "Edit Additional Tax Type" : "View Additional Tax Type"} </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid size={{ md: 12, xs: 12 }}>
              <TextField
                required
                id="name"
                label="Name"
                variant="outlined"
                size="small"
                fullWidth
                margin="normal"
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 50 } }}
                disabled={modeType === "view"}
                value={additionaltaxTypeData?.name || ""}
                onChange={(e) => {
                  regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("name", e.target.value.trimStart()) : e.preventDefault()
                  setError(prev => ({ ...prev, name: "" }));
                }}
                onFocus={() => onRestErrorKey("name")}
                error={error?.name || false}
                helperText={error?.name || ''}
              />
            </Grid>
            {/* Type selection temporarily disabled — Negative Tax Type support is on hold.
                Payload always sends type: 1 (Positive). Uncomment to re-enable. */}
            {/* <Grid size={{ md: 6, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                disabled={modeType === 'view'}
                options={AdditionalTaxTypeOptions}
                getOptionDisabled={opt => opt?.value === 2}
                getOptionLabel={opt => opt?.label || ''}
                value={AdditionalTaxTypeOptions.find(opt => opt.value === (typeof additionaltaxTypeData?.type === 'object' ? additionaltaxTypeData?.type?.value : additionaltaxTypeData?.type)) || null}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                onChange={(e, value) => handelInputChange('type', value?.value ?? null)}
                renderInput={params => (
                  <TextField {...params} label="Type" required size="small" margin="normal"
                    error={!!error.type}
                    helperText={error.type || ''}
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                )}
              />
            </Grid> */}
            {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
              <LessMoreTextFieldComp label='Remarks' value={additionaltaxTypeData?.remarks || ""} />
            </Grid> :
              <Grid size={{ md: 12, xs: 12 }}>
                <TextField
                  rows={3}
                  id="remarks"
                  label="Remarks"
                  variant="outlined"
                  size="small"
                  margin="normal"
                  fullWidth
                  multiline
                  slotProps={{ inputLabel: { shrink: true } }}
                  sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                  disabled={modeType === "view"}
                  value={additionaltaxTypeData?.remarks || ""}
                  onChange={(e) => {
                  regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                }}
                />
              </Grid>}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ marginRight: '15px' }}>
          <Button className='cancel-btn' disabled={isLoading} variant="outlined" size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
          {modeType === "view" ? null :
            <Button variant="contained" size='small' className="btn-primary" onClick={() => { handleItemClicked('Save Button'); addEditAdditionalTaxType(); }}>
              {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
            </Button>}
        </DialogActions>
      </Dialog>
    </>
  )
}

export default AdditionalTaxTypeCRU;